<template>
  <div v-if="schedule" class="schedule-info container">
    <div class="schedule-info__content">
      <div class="schedule-info__left">
        <h3 class="schedule-info__title">{{ schedule.name }}</h3>
        <p class="schedule-info__description">
          {{ formattedTime }} • {{ formattedDate }}
        </p>
        <p class="schedule-info__type">Групповая</p>
      </div>
      <div class="schedule-info__right" v-if="availablePlaces !== null">
        <p v-if="this.schedule.hide_number_of_available_setting !== 1 && availablePlaces > 0">Еще {{ availablePlaces }} {{ pluralPlaces(availablePlaces) }}</p>
        <p v-else-if="this.schedule.hide_number_of_available_setting === 1 && availablePlaces > 0">Места есть</p>
        <p v-else>Нет свободных мест</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { format } from "date-fns";
import { ru } from "date-fns/locale";

export default {
  name: "ScheduleInfo",
  data() {
    return {
      schedule: null,
    };
  },
  computed: {
    formattedTime() {
      if (!this.schedule) return "";
      return `${this.schedule.time_start.slice(0, 5)} – ${this.schedule.time_end.slice(0, 5)}`;
    },
    formattedDate() {
      if (!this.schedule) return "";

      const DAYS_SHORT = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
      const date = new Date(this.schedule.date);
      const day = DAYS_SHORT[date.getDay()];
      const formatted = format(date, "d MMMM", { locale: ru });

      return `${day}, ${formatted}`;
    },
    availablePlaces() {
      if (!this.schedule || this.schedule.records_limit === 0) return null;
      return this.schedule.records_limit - this.schedule.records_current;
    },
  },
  methods: {
    pluralPlaces(n) {
      if (n % 10 === 1 && n % 100 !== 11) return "место";
      if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return "места";
      return "мест";
    },
    async loadSchedule() {
      try {
        const { data } = await api.schedule.getSchedule(this.$route.params.scheduleId);
        this.schedule = data;
      } catch (e) {
        console.error("Ошибка при загрузке расписания:", e);
      }
    },
  },
  mounted() {
    this.loadSchedule();
  },
};
</script>

<style scoped>
.schedule-info {
  margin-bottom: 10px;
}

.schedule-info__content {
  display: flex;
  justify-content: space-between;
}

.schedule-info__title {
  font-weight: 700;
  font-size: 17px;
  line-height: 24px;
  letter-spacing: 0;
  margin-bottom: 8px;
}

.schedule-info__description{
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  vertical-align: middle;
  margin-bottom: 4px;
}

.schedule-info__type {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #757885;
}

.schedule-info__right p {
  border-radius: 8px;
  padding: 5px 12px;
  gap: 10px;
  opacity: 1;
  background: #FFFFFF;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #757885;
}

@media (max-width: 991.98px) {
  .schedule-info {
    padding: 0 40px;
  }

  .schedule-info__content {
    background-color: #fff;
    padding: 24px;
    border-radius: 12px;
  }

  .schedule-info__right p {
    background-color: #F9FAFB;
  }
}

@media (max-width: 767.98px) {
  .schedule-info {
    padding: 0 15px;
  }
}

</style>